import { dataToDataLayer } from './';

type experienceClickDataParams = {
   event_name: string;
   event_price: number;
   event_city: string;
};

export const languageChangeDataLayer = (language: string) => {
   dataToDataLayer({
      event: 'change_language',
      section_name: 'header',
      click_action: 'change',
      click_text: language,
   });
};

export const joinNowClickDataLayer = () => {
   dataToDataLayer({
      event: 'join_now',
      section_name: 'hero banner',
      click_action: 'click',
      click_text: 'join now',
   });
};

export const experienceClickDataLayer = (params: experienceClickDataParams) => {
   dataToDataLayer({
      event: 'view_experience',
      section_name: 'recent experiences',
      click_action: 'click',
      click_text: 'view experience',
      ...params,
   });
};

export const footerLinksClickDataLayer = (link: string) => {
   dataToDataLayer({
      event: 'footer_navigation',
      section_name: 'footer',
      click_action: 'click',
      click_text: link,
   });
};

export const socialShareClickDataLayer = (platform: string) => {
   dataToDataLayer({
      event: 'social_share',
      section_name: 'connect with us',
      click_action: 'click',
      click_text: platform,
   });
};
